import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm11.45 6.34-4.38 4.38a.74.74 0 0 1-.53.22.73.73 0 0 1-.54-.22L4.55 9.26a.74.74 0 0 1 0-1.06.75.75 0 0 1 1.06 0l.93.93 3.85-3.85a.75.75 0 0 1 1.06 1.06ZM14.74 8A6.75 6.75 0 1 1 8 1.25 6.75 6.75 0 0 1 14.74 8Zm-3.29-2.72a.75.75 0 0 0-1.06 0L6.54 9.13l-.93-.93a.75.75 0 0 0-1.06 0 .74.74 0 0 0 0 1.06L6 10.72a.73.73 0 0 0 .53.22.74.74 0 0 0 .53-.22l4.38-4.38a.75.75 0 0 0 .01-1.06Zm0 0a.75.75 0 0 0-1.06 0L6.54 9.13l-.93-.93a.75.75 0 0 0-1.06 0 .74.74 0 0 0 0 1.06L6 10.72a.73.73 0 0 0 .53.22.74.74 0 0 0 .53-.22l4.38-4.38a.75.75 0 0 0 .01-1.06Z';
const draw24px =
  'M21.75,12A9.75,9.75,0,1,1,12,2.25,9.76,9.76,0,0,1,21.75,12Zm-11.1,3.71,6.17-6.17a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0L9.94,13.59,8.59,12.24a1,1,0,0,0-1.41,1.41l2.06,2.06a1,1,0,0,0,.7.29A1,1,0,0,0,10.65,15.71Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CheckmarkCircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'checkmarkCircleFilled')) as IconWithRender;

CheckmarkCircleFilledIcon.displayName = 'CheckmarkCircleFilledIcon';
CheckmarkCircleFilledIcon.propTypes = Icon.propTypes;
CheckmarkCircleFilledIcon.renderIcon = (props) => (
  <CheckmarkCircleFilledIcon {...props} />
);
export default CheckmarkCircleFilledIcon;
